/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AuditEventActorResponse } from './auditEventActorResponse';
import type { AuditEventDeliveryResponse } from './auditEventDeliveryResponse';
import type { AuditEventResponseMetadata } from './auditEventResponseMetadata';
import type { AuditEventResponseSeverity } from './auditEventResponseSeverity';

export interface AuditEventResponse {
  id: string;
  action: string;
  category: string;
  severity: AuditEventResponseSeverity;
  summary: string;
  target_summary?: string | null;
  actor: AuditEventActorResponse;
  occurred_at: string;
  metadata?: AuditEventResponseMetadata;
  delivery: AuditEventDeliveryResponse;
}
